































































































































import { cloneDeep } from "lodash";
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import vSelect from 'vue-select'

import SearchTextInput
  from "../../../../../../components/Pi/fields/SearchTextInput/SearchTextInput.vue";
import SelectInput from "../../../../../../components/Pi/fields/SelectInput/SelectInput.vue";
import TextInput from "../../../../../../components/Pi/fields/TextInput/TextInput.vue";
import { FieldData } from '../../../../../../components/Pi/types'
import { errorNotificationWrapper } from "../../../../../../logic/helpers/NotificationService";
import PostApi from "../../../../includes/logic/Api/PostApi";
import BusinessRegistrationIntroIcon from "../components/BusinessRegistrationIntroIcon.vue";
import { CompanyData, CompanyRegistrationStep, DataOrganizations } from "../types";

@Component({
  computed: {
    CompanyRegistrationStep() {
      return CompanyRegistrationStep
    }
  },
  components: {
    vSelect,
    SelectInput,
    SearchTextInput,
    BusinessRegistrationIntroIcon,
    TextInput
  }
})

export default class CompanyDataTin extends Vue {
  @Prop() readonly value!: CompanyData

  @Emit()
  next(): { step: CompanyRegistrationStep } {
    return { step: CompanyRegistrationStep.EmailValidation }
  }

  isNotItems = false
  isLoadingStep = false
  isLoadingSearchTin = false
  isTin = false

  dataOrganizations: DataOrganizations[] = []

  overflow() {
    return this.dataOrganizations.length > 2
  }

  get companyData(): CompanyData {
    return cloneDeep(this.value)
  }

  inputConfigSetup(args: FieldData): FieldData {
    args.setter = (value: any): void => {
      this.value.inn = value
    }

    return args
  }

  onNextButtonClick() {
    this.next()
  }

  onSelectOrganizations(item: DataOrganizations) {
    this.value['inn'] = item.inn
    this.value['name'] = item.name
    this.isTin = true
    this.dataOrganizations = []
  }

  async onSearchButtonClick() {

    this.isLoadingSearchTin = true
    try {
      await PostApi.sendRequest('tg', 'SearchOrganization', { query: this.companyData.inn }).then(response => {
        if (response.data.items.length === 0) {
          this.isNotItems = true
        } else {
          this.dataOrganizations = response.data.items
        }
        this.isLoadingSearchTin = false
      })
    } catch (error: any) {
      errorNotificationWrapper(this.$t('error').toString(), error)
    }
  }

  onCheckClickPopup(e: any) {
    this.dataOrganizations = []
  }

  updated() {
    const titleInput = document.querySelector('[translation-key="field_company_registration_inn_title"]')
    const isElementHelp = document.getElementById('helper-tin')
    if (isElementHelp === null && titleInput !== null) {
      const nextElement = titleInput.nextElementSibling
      nextElement?.insertAdjacentHTML('afterend', `<p id="helper-tin" class="text-sm text-gray-500 mb-0">${ this.$t("field_company_registration_inn_helper") }</p>`)
    }
  }

  created() {

    // <p class="text-sm text-gray-400 mb-0">Для поиска организации введите название, ИНН, КПП или ОГРН.</p>
    window.addEventListener('click', this.onCheckClickPopup)
    return () => window.removeEventListener('click', this.onCheckClickPopup)
  }

}
